import { EXTERNAL_PRINT_STATUS } from '@/utils/external-print-constants';

export class BulkJobEntity {
  constructor({
    id,
    createdAt,
    updatedAt,
    insuredId = null,
    operation = null,
    status = null,
    bulkjobNumber = null,
    assignedUserId = null,
    assignedAt = null,
    assignedBy = null,
    externalPrintStatus = EXTERNAL_PRINT_STATUS.NONE,
  }) {
    this.id = id;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.insuredId = insuredId;
    this.operation = operation;
    this.status = status;
    this.bulkJobNumber = bulkjobNumber;
    this.assignedUserId = assignedUserId;
    this.assignedAt = assignedAt;
    this.assignedBy = assignedBy;
    this.externalPrintStatus = externalPrintStatus;
  }
}
